export const RPC_PREFIX = '/rpc';
export const RPC_TOOLS_PATH = '/rpc/_tools';
/** HTTP status for an error code, so client and server agree. */
export function statusForErrorCode(code) {
    switch (code) {
        case 'unauthenticated':
            return 401;
        case 'permission_denied':
            return 403;
        case 'not_found':
            return 404;
        case 'conflict':
            return 409;
        case 'validation':
        case 'invalid_state':
        case 'confirmation_required':
            return 422;
        case 'integration':
            return 502;
        default:
            return 500;
    }
}
//# sourceMappingURL=rpc.js.map